<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-container
      fluid
      :class="almost_mobile ? 'pt-3 stycard' : 'pt-6 px-5 stycard'"
      style="min-height: 100vh"
      v-if="check_signed(detailPhysicalExam)"
    >
      <v-row style="margin-top: 60px">
        <v-col cols="12">
          <v-card color="#EDF8F7" elevation="0" style="border-radius: 8px">
            <v-card-title
              ><v-avatar tile size="28" color="#EDF8F7" class="mr-2">
                <v-img src="@/assets/icon/document.svg" /> </v-avatar
              ><span style="font-size: 16px; font-weight: bold"
                >รายงานผลการตรวจร่างกายเบื้องต้น (Physical Examination)</span
              ></v-card-title
            >
            <v-card-text>
              <v-row>
                <v-avatar tile size="28" color="#EDF8F7" class="mr-2">
                </v-avatar>
                <v-col>
                  <v-col cols="12" xs="12" sm="7" md="5" class="pl-0 pt-0">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" class="card-text">
                        <v-row>
                          <v-col cols="4" class="pr-0 mt-2"
                            ><span>วันที่ตรวจ : </span></v-col
                          >
                          <v-col cols="8" class="pl-0">
                            <v-menu
                              v-model="menu_startDate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  dense
                                  label="วันที่"
                                  single-line
                                  readonly
                                  hide-details
                                  outlined
                                  solo
                                  color="#00a99d"
                                  append-icon="mdi-calendar"
                                  @click:append="menu_startDate = true"
                                  v-on="on"
                                  v-bind="attrs"
                                  :value="formatDate(value_startDate)"
                                ></v-text-field>
                                <!-- :value="oneForm.checkDate ? formatDate(oneForm.checkDate) : formatDate(value_startDate)"
                          -->
                              </template>
                              <v-date-picker
                                locale="th"
                                v-model="value_startDate"
                                @input="menu_startDate = false"
                                @change="setDate"
                                :max="today"
                                color="#329d9c"
                              ></v-date-picker> </v-menu
                          ></v-col>
                        </v-row>
                      </v-col>
                      <!-- <v-col cols="12" xs="12" sm="12" md="6" class="card-text">
                        <v-row>
                          <v-col cols="3" class="pr-0 mt-2"
                            ><span>คิวที่ : </span></v-col
                          >
                          <v-col cols="8" class="pl-0">
                            <v-text-field
                              v-model="queue"
                              dense
                              placeholder="กรุณากรอกคิว"
                              hide-details
                              outlined
                              solo
                              color="#00a99d"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col> -->
                    </v-row>
                  </v-col>
                  <v-row>
                    <v-col cols="12" xs="12" sm="6" md="4" class="card-text">
                      <span>บริษัท : </span>
                      <span style="font-weight: bold">{{
                        detailPhysicalExam.company
                          ? detailPhysicalExam.company
                          : "-"
                      }}</span>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6" md="4" class="card-text">
                      <span>ชื่อ-นามสกุล : </span>
                      <span style="font-weight: bold">{{
                        detailPhysicalExam.full_name_th
                          ? detailPhysicalExam.full_name_th
                          : "-"
                      }}</span>
                    </v-col>
                    <v-col
                      :cols="$vuetify.breakpoint.mdAndUp ? '4' : '6'"
                      class="card-text"
                    >
                      <span>อายุ : </span>
                      <span style="font-weight: bold"
                        >{{
                          calculateAge(detailPhysicalExam.birth_date) || detailPhysicalExam.age
                        }}
                        ปี</span
                      >
                    </v-col>
                    <v-col
                      :cols="$vuetify.breakpoint.mdAndUp ? '4' : '6'"
                      class="card-text"
                    >
                      <span>ตำแหน่ง : </span>
                      <span style="font-weight: bold">{{
                        detailPhysicalExam.position
                          ? detailPhysicalExam.position
                          : "-"
                      }}</span>
                    </v-col>
                    <v-col
                      :cols="$vuetify.breakpoint.mdAndUp ? '4' : '6'"
                      class="card-text"
                    >
                      <span>แผนก : </span>
                      <span style="font-weight: bold">{{
                        detailPhysicalExam.department
                          ? detailPhysicalExam.department
                          : "-"
                      }}</span>
                    </v-col>
                    <v-col
                      :cols="$vuetify.breakpoint.mdAndUp ? '4' : '6'"
                      class="card-text"
                    >
                      <span>รหัส : </span>
                      <span style="font-weight: bold">{{
                        detailPhysicalExam.employee_id
                          ? detailPhysicalExam.employee_id
                          : "-"
                      }}</span>
                    </v-col>
                    <v-col
                      :cols="$vuetify.breakpoint.mdAndUp ? '4' : '6'"
                      class="card-text"
                    >
                      <span>ตรวจวันที่ : </span>
                      <!-- {{ oneForm }} -->
                      <!-- {{ formatDate(oneForm.checkDate)}}
                      {{oneForm.checkDate}} -->
                      <span style="font-weight: bold">{{
                        this.oneForm
                          ? formatDate(this.oneForm.checkDate)
                          : displayDate(value_startDate)
                      }}</span>
                    </v-col>
                    <!-- <v-col
                      :cols="$vuetify.breakpoint.mdAndUp ? '4' : '6'"
                      class="card-text"
                    >
                      <span>ลำดับที่ : </span>
                      <span style="font-weight: bold">{{
                        this.oneForm ? this.oneForm.queue : this.queue
                      }}</span>
                    </v-col> -->
                  </v-row>
                </v-col>
                <!-- <v-col :cols="$vuetify.breakpoint.width > 1150 ? '2' : '12'">
                  <v-avatar tile size="130" class="pa-1"
                    ><v-img src="@/assets/img/qr-code.png"
                  /></v-avatar>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- <v-col class="pt-1">
          <pre>{{ model }}</pre>
          <v-tabs
            color="#00A99D"
            class="elevation-0"
            v-model="model"
            show-arrows
            grow
            center-active
            @change="test"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab
              class="tab pb-2"
              v-for="(item, n) in tab"
              :key="n"
              :href="getTabHref(n)"
            >
              <v-icon size="22" style="margin-right: 2px">{{
                item.icon
              }}</v-icon>
              {{ item.title }}
            </v-tab></v-tabs
          >
          <div>
            <v-tabs-items v-model="model" class="full-height-tab">
              <v-tab-item value="tab-0"
                ><Tab1General ref="form1"></Tab1General>
                <v-col><v-btn @click="next_tab('tab-1')">test0</v-btn></v-col>
              </v-tab-item>
              <v-tab-item value="tab-1"
                ><Tab2LabResult></Tab2LabResult
                ><v-col><v-btn @click="next_tab('tab-2')">test1</v-btn></v-col></v-tab-item
              >
              <v-tab-item value="tab-2"
                ><Tab3Treatment_etc></Tab3Treatment_etc></v-tab-item
              ><v-tab-item value="tab-3"
                ><Tab4BloodCount></Tab4BloodCount
              ></v-tab-item>
              <v-tab-item value="tab-4"
                ><Tab5UrineResults></Tab5UrineResults
              ></v-tab-item>
              <v-tab-item value="tab-5"
                ><Tab6Laboratory></Tab6Laboratory
              ></v-tab-item>
              <v-tab-item value="tab-6"><Tab7Summary></Tab7Summary></v-tab-item>
            </v-tabs-items>
          </div>
        </v-col> -->
        <v-col class="py-0">
          <v-tabs
            color="#00A99D"
            class="elevation-0"
            v-model="currentItem"
            show-arrows
            grow
            center-active
            @change="save_item('save','wait')"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab
              class="tab pb-2"
              v-for="(item, n) in tab"
              :key="n"
              style="font-size: 12px"
            >
              <v-icon size="15" style="margin-right: 2px">{{
                item.icon
              }}</v-icon>
              {{ item.title }}
            </v-tab></v-tabs
          >
          <div>
            <v-tabs-items v-model="currentItem" class="full-height-tab">
              <v-tab-item eager
                ><Tab1General ref="form1"></Tab1General>
              </v-tab-item>
              <v-tab-item eager
                ><Tab2LabResult ref="form2" :itemGender="gender"></Tab2LabResult
              ></v-tab-item>
              <v-tab-item eager
                ><Tab3Treatment_etc ref="form3"></Tab3Treatment_etc></v-tab-item
              ><v-tab-item eager
                ><Tab3_2Treatment_etc ref="form3_2"></Tab3_2Treatment_etc></v-tab-item
              ><v-tab-item eager
                ><Tab4BloodCount ref="form4"></Tab4BloodCount
              ></v-tab-item>
              <v-tab-item eager
                ><Tab5UrineResults ref="form5"></Tab5UrineResults
              ></v-tab-item>
              <v-tab-item eager
                ><Tab6Laboratory ref="form6"></Tab6Laboratory
              ></v-tab-item>
              <v-tab-item eager
                ><Tab7Summary ref="form7" @save_preview="save_item('saveAll','wait')" @add_form="save_item('saveAll','approve')" @goBack="isSaved = false"></Tab7Summary>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-col>

        <v-col cols="12" class="pa-10">
          <v-row>
            <v-btn width="180px" color="error" outlined class="card-medium-back" @click="$router.go(-1)"><span>ยกเลิก</span></v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="currentItem != 0 && currentItem != 7"
              depressed
              outlined
              color="#00a99d"
              @click="backward_tab"
              width="180px"
              class="card-medium-back"
              ><span>ย้อนกลับ</span></v-btn
            >
            <v-btn
              class="ml-3 card-medium"
              v-if="currentItem != 7"
              draggable=""
              dark
              color="#00a99d"
              @click="next_tab"
              width="180px"
              ><span>{{ currentItem != 7 ? "ถัดไป" : "บันทึก" }}</span></v-btn
            >
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-3 stycard' : 'pt-10 px-5 stycard'"
      style="min-height: 100vh"
      v-else
    >
      <pdf
        height="590px"
        width="600px"
        :src="pdfsrc"
        v-for="i in numPages"
        :key="i"
        :page="i"
      />
    </v-container>

    <BeforeLeavePhysical ref="beforeleave_dialog"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Tab1General from "../views/TabPhysicalExam/Tab1General.vue";
import Tab2LabResult from "../views/TabPhysicalExam/Tab2LabResult.vue";
import Tab3Treatment_etc from "../views/TabPhysicalExam/Tab3Treatment_etc.vue";
import Tab3_2Treatment_etc from "../views/TabPhysicalExam/Tab3_2Treatment_etc.vue";
import Tab4BloodCount from "../views/TabPhysicalExam/Tab4BloodCount.vue";
import Tab5UrineResults from "../views/TabPhysicalExam/Tab5UrineResults.vue";
import Tab6Laboratory from "../views/TabPhysicalExam/Tab6Laboratory.vue";
import Tab7Summary from "../views/TabPhysicalExam/Tab7Summary.vue";
import BeforeLeavePhysical from "../components/dialog/beforeLeavePhysical.vue";
import { EventBus } from "../EventBus";
import pdf from "vue-pdf";
import moment from "moment";

export default {
  components: {
    Tab1General,
    Tab2LabResult,
    Tab3Treatment_etc,
    Tab3_2Treatment_etc,
    Tab4BloodCount,
    Tab5UrineResults,
    Tab6Laboratory,
    Tab7Summary,
    pdf,
    BeforeLeavePhysical
  },
  data() {
    return {
      model: "tab-0",
      menu_startDate: false,
      value_startDate: "",
      oneForm: [],
      queue: "",
      gender:"",
      tab: [
        {
          title: "สภาพร่างกายทั่วไป",
          icon: "mdi-file-document",
        },
        {
          title: "ผลตรวจทางห้องปฏิบัติการ(1)",
          icon: "mdi-flask-outline",
        },
        {
          title: "ผลตรวจอื่นๆ(1)",
          icon: "mdi-file-chart-outline",
        },
        {
          title: "ผลตรวจอื่นๆ(2)",
          icon: "mdi-file-chart-outline",
        },
        {
          title: "ผลการตรวจนับเม็ดเลือด",
          icon: "mdi-water",
        },
        {
          title: "ผลตรวจปัสสาวะ",
          icon: "mdi-needle",
        },
        {
          title: "ผลตรวจทางห้องปฏิบัติการ(2)",
          icon: "mdi-test-tube",
        },
        {
          title: "สรุปผลการตรวจ",
          icon: "mdi-file-account",
        },
      ],
      currentItem: 0,
      oneId: null,
      cid: null,
      pdf: "",
      loading: true,
      role_name:sessionStorage.role_name,
      numPages: undefined,
      pdfsrc:null,
      isSaved: false
    };
  },
  computed: {
    ...mapState(["statusPhy_notification","detailPhysicalExam", "biz"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  async created() {
    this.queue = this.detailPhysicalExam.queue;
    console.log("this.detailPhysicalExam.", this.detailPhysicalExam);
    await this.getPatient()
    if(this.statusPhy_notification){
      this.currentItem = 7;
    }
    EventBus.$emit("detailAll_GetOneFormPost", this.detailPhysicalExam);
    var now_date = new Date();
    this.today =
      now_date.getFullYear() +
      "-" +
      (now_date.getMonth() + 1 >= 10
        ? now_date.getMonth() + 1
        : "0" + (now_date.getMonth() + 1)) +
      "-" +
      (now_date.getDate() >= 10
        ? now_date.getDate()
        : "0" + now_date.getDate().toString());
    // this.value_startDate = this.today;
    this.value_startDate = this.detailPhysicalExam.checkDate;
    this.getOneForm();
    if (
      this.detailPhysicalExam.file_id &&
      this.detailPhysicalExam.file_id !== ""
    ) {
      await this.getPdf_v2();
    }else if (this.detailPhysicalExam.status == "Cancel" || (this.detailPhysicalExam.status == "Approve" && this.role_name != "แพทย์")  || (this.detailPhysicalExam.status == "Success" && this.role_name == "แพทย์")){
      await this.genPdf_base();
    }
    this.loading = false;
  },
  beforeDestroy() {
  },
  methods: {
    ...mapMutations(["setDetailRefAll", "setDetailAll_GetOneForm"]),
    // test(e) {
    //   console.log("test", e);
    // },
    displayDate(date) {
      if (date) {
        var [year, month, day] = date.split("-");
        return `${day}/${month}/${parseInt(year) + 543}`;
      }
      return "";
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      var [year, month, day] = date.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
    calculateAge(date) {
      if (date) {
        if (date) {
          const y = Math.floor(moment.duration(moment().diff(date)).asYears());
          return y.toString();
        }
        return null;
      }
    },
    next_tab(e) {
      if (this.currentItem < this.tab.length - 1) {
        console.log("this.currentItem", this.currentItem);
        
        if (this.currentItem == 7) {
          this.save_item("saveAll",'wait');
        } else {
          this.save_item("save",'wait');
        }
        this.currentItem++;
      }
      this.model = e;
    },
    backward_tab() {
      if (this.currentItem > 0) {
        this.currentItem--;
      }
    },
    setDate() {
      this.save_item("save");
    },
    async getOneForm() {
      try {
        // this.oneId = this.detailPhysicalExam.one_id;
        // let check_date = this.detailPhysicalExam.checkDate.split("-")[0]
        // this.cid = String(this.detailPhysicalExam.cid);
        let params = new URLSearchParams()
        params.append("id", this.detailPhysicalExam._id)
        params.append("year", this.detailPhysicalExam.year)
        params.append("biz_id", this.biz.biz_id)

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/findOneForm?${params}`,
          // {
          //   params: {
          //     id:this.detailPhysicalExam._id
          //   }
          // }
        ).then((res) => {
          if (res.data.result === "success") {
            this.oneForm = res.data.data;
            this.queue = this.oneForm ? this.oneForm.queue : "";
            if (this.detailPhysicalExam.send_data){
              res.data.data.send_data = true
            }
            EventBus.$emit("detailAll_GetOneForm", res.data.data);
            this.setDetailAll_GetOneForm(res.data.data);
            // this.value_startDate = this.detailPhysicalExam.checkDate;
          }
        });
      } catch (error) {
        console.log('error',error);
      }
    },
    save_item(status,statusDocument) {
      try {
        
        let status_doc = "Wait"
        if (this.currentItem == 7 && 
        // this.role_name != "แพทย์" && 
        statusDocument == "approve"){
          status_doc = "Approve"
        }
        const yearData = 'checkDate' in this.oneForm && this.oneForm ? this.oneForm.checkDate.split("-")[0]: this.value_startDate.split("-")[0];
        // let defaul = {
        //   urine: {
        //     gravity_result_min: 1.003,
        //     gravity_result_max: 1.035,
        //     ph_result_min: 5.0,
        //     ph_result_max: 8.0,
        //     glucose_result: "negative",
        //     protein_result: "negative",
        //     blood_result: "negative",
        //     wbc_result_min: 0,
        //     wbc_result_max: 1,
        //     rbc_result_min: 0,
        //     rbc_result_max: 3,
        //     cell_result_min: 0,
        //     cell_result_max: 1
        //   }
        // }
        // let status_urine = {}
        // let urine = this.$refs.form5._data.item_urinalysis[0].UrineResults
        // let summaryBpPuls = this.$refs.form1._data.General.summaryBpPuls
        // if (summaryBpPuls.split(' ').length > 1){
        //   summaryBpPuls = summaryBpPuls.split(' ')[0]
        // }
        // console.log(this.$refs.form5._data.item_urinalysis[0].UrineResults);
        // console.log(urine);

        // if(
        //   urine &&
        //   (Number(urine.urineStrip.specificGravity.result) >= defaul.urine.gravity_result_min && Number(urine.urineStrip.specificGravity.result) <= defaul.urine.gravity_result_max) &&
        //   (Number(urine.urineStrip.ph.result) >= defaul.urine.ph_result_min && Number(urine.urineStrip.ph.result) <= defaul.urine.ph_result_max) &&
        //   (urine.urineStrip.glucose.result.toString().toLowerCase() == defaul.urine.glucose_result) &&
        //   (urine.urineStrip.protein.result.toString().toLowerCase() == defaul.urine.protein_result) &&
        //   (urine.urineStrip.blood.result.toString().toLowerCase() == defaul.urine.blood_result) &&
        //   (Number(urine.urineMicroscopy.wbc.result) >= defaul.urine.wbc_result_min && Number(urine.urineMicroscopy.wbc.result) <= defaul.urine.wbc_result_max) &&
        //   (Number(urine.urineMicroscopy.rbc.result) >= defaul.urine.rbc_result_min && Number(urine.urineMicroscopy.rbc.result) <= defaul.urine.rbc_result_max) &&
        //   (Number(urine.urineMicroscopy.epithelialCell.result) >= defaul.urine.cell_result_min && Number(urine.urineMicroscopy.epithelialCell.result) <= defaul.urine.cell_result_max)
        // ){
        //   status_urine.urine_status = "ปกติ"
        // }else{
        //   status_urine.urine_status = "ผิดปกติ"
        // }
        // this.$refs.form7._data.summary[0].general_status = this.$refs.form1._data.General.comment
        // this.$refs.form7._data.summary[1].blood_status = this.$refs.form4._data.bloodCount[0].blood.completeBloodCount.summaryBloodCount
        // this.$refs.form7._data.summary[2].urine_status = urine.summaryurine
        // this.$refs.form7._data.summary[3].x_ray_status = this.$refs.form1._data.General.chestXray
        // this.$refs.form7._data.summary[4].vision_status = this.$refs.form1._data.General.visionTest
        // this.$refs.form7._data.summary[5].pressure_status = summaryBpPuls
        // this.$refs.form7._data.summary[6].b_virus_status = this.$refs.form2._data.HepatitisB.HBsAg.summary
        // this.$refs.form7._data.summary[7].hdl_status = this.$refs.form6._data.item_laboratory[0].Lab.Laboratory.bloodLipidLevel.HDLCholesterol.summary
        // this.$refs.form7._data.summary[8].ldl_status = this.$refs.form6._data.item_laboratory[0].Lab.Laboratory.bloodLipidLevel.LDLCholesterol.summary
        const data = {
          // one_id: sessionStorage.oneId,
          one_id: this.detailPhysicalExam.one_id,
          cid: this.detailPhysicalExam.cid,
          year: yearData,
          birth_date:this.detailPhysicalExam.birth_date,
          patient_id:this.detailPhysicalExam.patient_id,
          // bizId: sessionStorage.biz_id,
          bizId: this.detailPhysicalExam.bizId, //ต้องยึดตามรายชื่อคนไข้หรือ getOneform??
          checkDate: this.value_startDate,
          queue: this.oneForm ? this.oneForm.queue : this.queue,
          pageToSign: 7,
          general: {
            general: this.$refs.form1._data.General,
            occupationVisionTest: this.$refs.form1._data.OccupationVisionTest,
            audioGraphy: this.$refs.form1._data.AudioGraphy,
            lungFunctionTest: this.$refs.form1._data.lungFunctionTest,
          },
          labResult: {
            liverFunction: this.$refs.form2._data.LiverFunction,
            kidneyFunction: this.$refs.form2._data.KidneyFunction,
            uricAcidFunction: this.$refs.form2._data.UricAcidFunction,
            bloodGroupDetection: this.$refs.form2._data.BloodGroupDetection,
            hepatitisA: this.$refs.form2._data.hepatitisA,
            hepatitisB: this.$refs.form2._data.HepatitisB,
            hepatitisC: this.$refs.form2._data.hepatitisC,
            urine: this.$refs.form2._data.Urine,
          },
          treatmentEtc: {
            other: this.$refs.form3._data.other,
            performance: this.$refs.form3._data.other2[0].length > 0 ? this.$refs.form3._data.other2[0][0].performance : this.$refs.form3._data.other2[0].performance,
            stoolExam: this.$refs.form3._data.stool_Exam[5].value, // ส่งตาม other แต่หลังบ้านเป็นแบบอาร์เรย์
            stool: {
              color: this.$refs.form3._data.stool_Exam[0].value,
              anatomy: this.$refs.form3._data.stool_Exam[1].value,
              rbc_cell: this.$refs.form3._data.stool_Exam[2].value,
              wbc_cell: this.$refs.form3._data.stool_Exam[3].value,
              parasites: this.$refs.form3._data.stool_Exam[4].value,
              stool_culture: this.$refs.form3._data.stool_Exam[6].value,
              occuolt_blood: this.$refs.form3._data.stool_Exam[7].value
            }
          },
          bloodCount: {
            completeBloodCount:
              this.$refs.form4._data.bloodCount[0].blood.completeBloodCount,
          },
          urineResults: this.$refs.form5._data.item_urinalysis[0].UrineResults,
          laboratory: this.$refs.form6._data.item_laboratory[0].Lab.Laboratory,
          other_list: this.$refs.form3_2._data.other_list,
          summary: this.$refs.form7._data.summary,
          doctor: this.$refs.form7._data.dataAll_forDownload.doctor,
          status:status_doc
          // doctor: {
          //   doctor_name: `${sessionStorage.getItem("accountName")} (ว. 567891)`,
          //   position: "แพทย์อาชีวเวชศาสตร์",
          // },
        };
        console.log(data,'data');
        
          this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/addForm`, data).then((response) => {
            this.isSaved = true
          // this.axios.post(`http://localhost:5000/v1/addForm`, data).then((response) => {
            // console.log(status, response.data.result);
            if (response.data.result == "success" && status == "saveAll") {
              // this.$swal.fire({
              //   icon: "success",
              //   title: "บันทึกสุขภาพเสร็จสิ้น",
              //   showConfirmButton: false,
              //   timer: 1000,
              // })
              // .then(() => {
                this.getOneForm(this.value_startDate);
                this.setDetailRefAll(data);
              // });
            } else {
              // console.log("save", status);
              this.setDetailRefAll(data);
              this.getOneForm(this.value_startDate);
              EventBus.$emit("detailAll_GetOneFormPost", data);
            }
          }).catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.log('error',error);
      }
    },

    getTabHref(index) {
      return `#tab-${index}`;
    },
    check_signed(item) {
      if ('file_id' in item && item.file_id && item.file_id !== "") {
        return false;
      } else if ('status' in item && item.status == "Cancel" || (this.detailPhysicalExam.status == "Approve" && this.role_name != "แพทย์")){
        return false;
      } else if (!item.file_id && 'status' in item && item.status == "Success") {
        return false;
      } else if (!item.file_id || item.file_id === "") {
        return true;
      }
    },
    async getPdf() {
      try {
        let params = new URLSearchParams();
        params.append("file_id", this.detailPhysicalExam.file_id);
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/healthCheckPdfToBase?${params}`
          )
          .then((res) => {
            // console.log("res", res)
            this.pdf = res.data.data;
            // console.log("pdf data", this.pdf)
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getPdf_v2() {
      try {
        let params = new URLSearchParams();
        params.append("file_id", this.detailPhysicalExam.file_id);
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/healthCheckPdfToBase?${params}`
          )
          .then(async(res) => {
            // console.log("res", res)
            this.pdfsrc = await pdf.createLoadingTask(`data:application/pdf;base64,${res.data.data}`);
            this.pdfsrc.promise.then(pdf => {
            this.numPages = pdf.numPages;
            });
            // console.log("pdf data", this.pdf)
          });
      } catch (err) {
        console.log(err);
      }
    },
    async genPdf_base() {
      try {
        const payload = {
          doc_id:this.detailPhysicalExam._id
        }
        await this.axios
        .post(
        `${process.env.VUE_APP_BACKEND_URL}/v2/sign/create-pdf`,
          payload,
        )
        .then(async(res) => {
          this.pdfsrc = await pdf.createLoadingTask(`data:application/pdf;base64,${res.data.data}`);
          this.pdfsrc.promise.then(pdf => {
            this.numPages = pdf.numPages;
          });
        })
      } catch (err) {
        console.log(err);
      }
    },
    async getPatient() {
      try {
        const params = new URLSearchParams();
            params.append("id", this.detailPhysicalExam.patient_id);
            await this.axios
              .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients?${params}`)
              .then((res) => {
                if (res.data.data) {
                  this.gender = res.data.data.gender
                  if (!this.gender){
                    if (res.data.data.account_title_th == "เด็กชาย" || res.data.data.account_title_th == "นาย"){
                      this.gender = "ชาย"
                    }else{
                      this.gender = "หญิง"
                    }
                  }
                }
              })
              .catch((err) => {
                console.log("axios get transactions err: ", err.message);
            });
      } catch (err) {
      console.log("🚀 ~ getPatient ~ err:", err) 
    }
  }
  },
  beforeRouteLeave: function(to, from, next) {
    console.log("to", to);
    console.log("from", from);
    if (this.isSaved && this.$route.query.from === 'dashboard') {
      this.$refs.beforeleave_dialog.openDialog(next);
    } else {
      next()
    }
  },
};
</script>

<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #ffffff;
  border-radius: 80px 0px 0px 0px;
}
.card-text {
  font-size: 14px;
  color: black;
}
/* .v-tabs-items.full-height-tab .v-window-item {
  height: calc(85vh); 
} */
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-back {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
</style>
